import {
  AnalysisDivision,
  CodeType,
  CodeTypeMap,
  ReportType,
} from 'constants/AnalysisConstant'
import i18n from '../i18n'

export const isEEGNorm = (
  codeTypeDivision: AnalysisDivision,
  codeType: CodeType,
) => codeTypeDivision === 'EEG' && codeType === CodeTypeMap.Normative

export const availableStatusToI18nString = (
  status: 'SUCCESS' | 'FAIL' | 'PAIR',
) => {
  switch (status) {
    case 'SUCCESS':
      return 'IStatus_success'
    case 'FAIL':
      return 'IStatus_failure'
    case 'PAIR':
      return 'IStatus_failure'
    default:
      return 'IUnknown'
  }
}

export const statusToI18nString = (status: AnalysisStatus): string => {
  switch (status) {
    case '-':
      return '-'
    case 'READY':
      return 'IStatus_ready'
    case 'PROCESSING':
      return 'IStatus_processing'
    case 'SUCCESS':
      return 'IStatus_success'
    case 'ERROR':
      return 'IStatus_failure'
    case 'LACK_OF_MONEY':
      return 'IStatus_lackOfMoney'
    case 'ICA':
      return 'IStatus_ica'
    case 'TIME_REJECTION':
      return 'IStatus_tsr'
    case 'PARTIALLY_COMPLETED':
      return 'IStatus_PartiallyCompleted'
    default:
      return '-'
  }
}

export const statusToI18nStringPremium = (
  additionalAnalysis: AnalysisStatus,
  progress: AnalysisStatus,
  reportType: ReportType,
): string => {
  let status
  if (reportType === 'P2' && additionalAnalysis) {
    status = additionalAnalysis
  } else if (reportType === 'P2') {
    status = progress
  } else return '-'

  switch (status) {
    case 'READY':
      return 'IStatus_ready'
    case 'PROCESSING':
      return 'IStatus_processing'
    case 'SUCCESS':
      return 'IStatus_success'
    case 'ERROR':
      return 'IStatus_failure'
    case 'PARTIALLY_COMPLETED':
      return 'IStatus_PartiallyCompleted'
    default:
      return '-'
  }
}

export const isReadable = (status: AnalysisStatus) =>
  status === 'SUCCESS' || status === 'ICA' || status === 'TIME_REJECTION'

export const isReadDisable = (status: AnalysisStatus) =>
  status === 'ERROR' || status === 'READY' || status === 'PROCESSING'

export const getEyeStatus = (status: string) => {
  switch (status) {
    case 'EO':
      return i18n.t('IEO')
    case 'EC':
      return i18n.t('IEC')
    case 'Eyes Open':
      return i18n.t('IEO')
    case 'Eyes Closed':
      return i18n.t('IEC')

    default:
      return '-'
  }
}

export const getGenderStatus = (status: string) => {
  switch (status) {
    case 'Male':
      return i18n.t('IGenderMale')
    case 'Female':
      return i18n.t('IGenderFemale')
    case '남자':
      return i18n.t('IGenderMale')
    case '여자':
      return i18n.t('IGenderFemale')
    case 'Man':
      return i18n.t('IGenderMale')
    case 'Woman':
      return i18n.t('IGenderFemale')
    default:
      return '-'
  }
}

export const getTextHRVPremium = (reportType: ReportType) => {
  switch (reportType) {
    case 'NONE':
      return i18n.t('IStatus_failure')
    case 'P1':
      return '-'
    case 'P2':
      return i18n.t('IStatus_success')
    default:
      return '-'
  }
}

export const getValidValue = (data: any[]) => {
  const dataValid = data.filter(
    // eslint-disable-next-line eqeqeq
    (item) => item && (item != undefined || item != null),
  )
  const set = new Set(dataValid)
  return Array.from(set)
}

export const compareTwoArray = (arr1: string[], arr2: string[]) => {
  const sortedArr1 = arr1.sort()
  const sortedArr2 = arr2.sort()
  return (
    sortedArr1.length === sortedArr2.length &&
    sortedArr1.every((value, index) => value === sortedArr2[index])
  )
}

export const getHandStatus = (status: string) => {
  switch (status) {
    case '오른손잡이':
      return '오른손'
    case '왼손잡이':
      return '왼손'
    case '양손잡이':
      return '양손'
    case '손잡이모름':
      return '모름'
    default:
      return status
  }
}

export const simpleSanitizeHTML = (html: string) => {
  if (!html || typeof html !== 'string') {
    return ''
  }
  const tempDiv = document.createElement('div')
  tempDiv.innerHTML = html
  const allowedTags = ['br', 'strong', 'b', 'em', 'i', 'u', 'span', 'p']
  const allElements = tempDiv.querySelectorAll('*')
  for (let i = allElements.length - 1; i >= 0; i -= 1) {
    const element = allElements[i]
    const tagName = element.tagName.toLowerCase()
    if (!allowedTags.includes(tagName)) {
      const parent = element.parentNode
      while (element.firstChild) {
        parent?.insertBefore(element.firstChild, element)
      }
      parent?.removeChild(element)
    } else {
      const attributes = Array.from(element.attributes)
      attributes.forEach((attr) => {
        if (attr.name !== 'class') {
          element.removeAttribute(attr.name)
        }
      })
    }
  }
  return tempDiv.innerHTML
}

export const decodeHTMLEntities = (str: string) => {
  const textarea = document.createElement('textarea')
  textarea.innerHTML = str
  return textarea.value
}
